export default {
  getConfig: state => state.data
}



// WEBPACK FOOTER //
// ./src/store/modules/company_settings/getters.js